"use client";

import { useRef, ChangeEvent } from "react";
import { Button } from "@drpcrd/shared/ui";
import { CloudUpload } from "lucide-react";

type ChatFileUploadProps = {
  onFileSelect?: (files: FileList) => void;
  disabled?: boolean;
  accept?: string;
  multiple?: boolean;
};

export const ChatFileUpload = ({
  onFileSelect,
  disabled = false,
  accept = "image/*,application/pdf",
  multiple = true,
}: ChatFileUploadProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && onFileSelect) {
      onFileSelect(event.target.files);
      // Reset the input so the same file can be selected again if needed
      event.target.value = "";
    }
  };

  return (
    <>
      <Button
        type="button"
        className="p-1"
        variant="outlined"
        disabled={disabled}
        onClick={() => fileInputRef.current?.click()}
      >
        <CloudUpload />
      </Button>
      <input
        type="file"
        accept={accept}
        className="hidden"
        onChange={handleFileSelect}
        multiple={multiple}
        ref={fileInputRef}
        disabled={disabled}
      />
    </>
  );
};
